import React from "react";
import TopHeader from "../../../components/TopHeader.tsx";
import resBlack from "./../../../assets/icons/bank.png";
import BankDetails from "./componenets/BankDetails.tsx";
import WidthdrawDetails from "./componenets/WidthdrawDetails.tsx";

const ManageRestaurant = () => {
  const [menuSelection, setMenuSelection] = React.useState(0);
  const changeMenu = (props) => {
    setMenuSelection(props);
  };
  return (
    <div>
      <TopHeader />
      <div className="d-flex kycScroll" style={{ overflow: "scroll" }}>
        <div className="d-flex" style={{ width: "107vw" }}>
          <div className="">
            {/* <div className="searchBoxForProduct" style={{ padding: "10px" }}>
              <input
                type="text"
                placeholder="Search"
                className="form-control searchBar"
              />
            </div> */}

            <div
              className="scrollable-div"
              style={{ width: "13rem", height: "100vh" }}
            >
              <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
                <b> Restaurant Settings</b>
              </h6>
              <hr className="" style={{ margin: ".5rem" }} />

              <div
                className={`menuItem ${menuSelection == 0 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(0)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={resBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Bank Details
                  </p>
                </div>
              </div>

              <div
                className={`menuItem ${menuSelection == 1 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(1)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={resBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Withdraw Requests
                  </p>
                </div>
              </div>
            </div>
          </div>
          {menuSelection === 0 ? (
            <>
              <BankDetails />
            </>
          ) : (
            <></>
            // <span>Nothing Found</span>
          )}

          {menuSelection === 1 ? (
            <>
              <WidthdrawDetails />
            </>
          ) : (
            <span>Nothing Found</span>
          )}

          {/* {menuSelection === 0 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <RestaurantSetupPage />
            </div>
          ) : menuSelection === 1 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <VATSetupPage />
            </div>
          ) : menuSelection === 3 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <EmployeeSetupPage />
            </div>
          ) : menuSelection === 4 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <ServiceChargeSetupPage />
            </div>
          ) : menuSelection === 5 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <KitchenSetupPage />
            </div>
          ) : menuSelection === 6 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <TableSetupPage />
            </div>
          ) : menuSelection === 7 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <FoodCategorySetupPage />
            </div>
          ) : menuSelection === 8 ? (
            <div className="" style={{ marginLeft: "10px", width: "78%" }}>
              <BankDetailsSetup />
            </div>
          ) : (
            <p>Coming soon</p>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default ManageRestaurant;
